import { Box, IconButton, LinearProgress, Stack } from "@mui/material";
import { FC, useCallback } from "react";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import SidebarSvgIcon from "@/assets/icons/app-related/SidebarSvgIcon";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { toggleRecommendationDrawerExpanded } from "@/store/infrastructure-architecture/infrastructureArchitectureSlice";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { infrastructureArchitectureRecommendationLoadingSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureRecommendationLoadingSelector";

interface InfrastructureArchitectureRecommendationDrawerHeaderProps {
  enableLoading?: boolean;
}

export const InfrastructureArchitectureRecommendationPanelHeader: FC<
  InfrastructureArchitectureRecommendationDrawerHeaderProps
> = ({ enableLoading }) => {
  const dispatch = useAppDispatch();
  const recommendationLoading = useAppSelector(
    infrastructureArchitectureRecommendationLoadingSelector,
  );

  const expandHandler = useCallback(() => {
    dispatch(toggleRecommendationDrawerExpanded());
  }, [dispatch]);

  return (
    <Stack position="relative">
      <Stack
        direction="row"
        justifyContent="space-between"
        width="100%"
        py={1.5}
        px={2}
        borderRadius={2}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          overflow="hidden"
        >
          <LightbulbOutlinedIcon fontSize="small" />
          <TypographyWithTooltip
            title="Recommendation"
            variant="body1"
            fontWeight="medium"
          />
        </Stack>

        <IconButton size="small" onClick={expandHandler}>
          <SidebarSvgIcon fontSize="inherit" />
        </IconButton>
      </Stack>

      {recommendationLoading && enableLoading && (
        <Box position="absolute" bottom={0} left={0} right={0}>
          <LinearProgress
            sx={{
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
            }}
          />
        </Box>
      )}
    </Stack>
  );
};
